// src/components/SinAcceso.js
// Aviso cuando una dirección con identificador (etapa 3 del enrutador) pide un
// registro que no existe, que es de otro usuario o cuyo id no tiene formato
// válido. Es el MISMO aviso en los tres casos: no revela si el registro existe.
// No pinta nada del registro: quien lo usa no muestra datos parciales mientras
// carga. La protección real sigue siendo login + RLS.
import { C, g } from '../constants';

export default function SinAcceso({ onVolver, textoVolver = 'Volver' }) {
  return (
    <div role="alert" style={{ ...g.card, maxWidth: 520, margin: '24px auto', textAlign: 'center', padding: '28px 24px' }}>
      <div style={{ fontSize: 15, fontWeight: '700', color: C.navy, marginBottom: 6 }}>
        No se puede abrir este registro
      </div>
      <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.5, marginBottom: onVolver ? 16 : 0 }}>
        No existe o tu usuario no tiene acceso a él. Si te enviaron el enlace,
        confirma que sea de tu cuenta.
      </div>
      {onVolver && (
        <button style={{ ...g.btn(C.teal), fontSize: 13 }} onClick={onVolver}>{textoVolver}</button>
      )}
    </div>
  );
}

// Mientras se confirma el acceso: solo un rótulo neutro, nada del registro.
export function CargandoRegistro() {
  return (
    <div style={{ ...g.card, textAlign: 'center', padding: '30px', color: C.muted, fontSize: 13 }}>Cargando…</div>
  );
}
